const actionTypes = {
  DEVICES_REQUEST_SUCCESSFUL: 'DEVICES_REQUEST_SUCCESSFUL',
  DEVICES_REQUEST_UNSUCCESSFUL: 'DEVICES_REQUEST_UNSUCCESSFUL',
  REQUEST_DEVICES: 'REQUEST_DEVICES',
  SET_DEVICE_PAGE: 'SET_DEVICE_PAGE',
  SET_DEVICE_SEARCH_QUERY: 'SET_DEVICE_SEARCH_QUERY',
  SET_REQUESTING_DEVICES: 'SET_REQUESTING_DEVICES',

  // Register device
  REGISTER_DEVICE: 'REGISTER_DEVICE',
  SET_REGISTERING_DEVICE: 'SET_REGISTERING_DEVICE',
  SET_REGISTER_DEVICE_ERROR: 'SET_REGISTER_DEVICE_ERROR',

  // Ship options for device management (fetched from device/ships)
  REQUEST_SHIP_OPTIONS: 'REQUEST_SHIP_OPTIONS',
  SET_REQUESTING_SHIP_OPTIONS: 'SET_REQUESTING_SHIP_OPTIONS',
  SHIP_OPTIONS_REQUEST_SUCCESSFUL: 'SHIP_OPTIONS_REQUEST_SUCCESSFUL',
  SHIP_OPTIONS_REQUEST_UNSUCCESSFUL: 'SHIP_OPTIONS_REQUEST_UNSUCCESSFUL',
}

export default actionTypes
